var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { EnterFullscreen, ExitFullscreen } from '@volkswagen-onehub/icons-core';
import { getCommonProps } from '../helpers/common-props';
import { CTA } from '../call-to-action';
const requestFullscreenMethods = [
    'requestFullscreen',
    'webkitRequestFullscreen',
];
export function MediaGalleryFullscreenButton(_a) {
    var { elementRef, isActiveAriaLabel, isInActiveAriaLabel, onClick, size } = _a, otherProps = __rest(_a, ["elementRef", "isActiveAriaLabel", "isInActiveAriaLabel", "onClick", "size"]);
    const [isFullscreen, setFullscreen] = React.useState(Boolean(document.fullscreenElement));
    const [isFullscreenAvailable, setIsFullscreenAvailable] = React.useState(false);
    const commonProps = getCommonProps(otherProps);
    React.useEffect(() => {
        setIsFullscreenAvailable(requestFullscreenMethods.some((prop) => { var _a; return Boolean((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a[prop]); }));
    }, [setIsFullscreenAvailable, elementRef]);
    const handleFullScreenChange = React.useCallback(() => {
        setFullscreen(Boolean(document.fullscreenElement));
    }, [setFullscreen]);
    const handleFullscreenClick = React.useCallback(() => {
        var _a, _b;
        if (document.fullscreenElement) {
            document.exitFullscreen();
            setFullscreen(false);
            return;
        }
        if (document.webkitFullscreenElement) {
            (_a = document.webkitExitFullscreen) === null || _a === void 0 ? void 0 : _a.call(document);
            setFullscreen(false);
            return;
        }
        const element = elementRef.current;
        const methodName = requestFullscreenMethods.find((method) => element === null || element === void 0 ? void 0 : element[method]);
        if (methodName) {
            (_b = element === null || element === void 0 ? void 0 : element[methodName]) === null || _b === void 0 ? void 0 : _b.call(element);
            onClick === null || onClick === void 0 ? void 0 : onClick();
            setFullscreen(true);
        }
    }, [elementRef, onClick]);
    React.useEffect(() => {
        document.addEventListener('fullscreenchange', handleFullScreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullScreenChange);
        };
    }, [handleFullScreenChange]);
    if (!isFullscreenAvailable) {
        return null;
    }
    return (React.createElement(CTA, Object.assign({ icon: isFullscreen ? (React.createElement(ExitFullscreen, { ariaHidden: true })) : (React.createElement(EnterFullscreen, { ariaHidden: true })), tag: "button", emphasis: "tertiary", onClick: handleFullscreenClick, ariaLabel: isFullscreen ? isActiveAriaLabel : isInActiveAriaLabel, size: size }, commonProps)));
}
